import { useState } from "react";
import { Link } from "react-router-dom";
import { leaderboard, badges } from "@/mocks/artistData";
import Navbar from "@/pages/home/components/Navbar";

const rankColors = ["#ffd60a", "#c0c0c0", "#cd7f32"];

const myStats = [
  { label: "완료한 캠페인", value: "12", icon: "ri-sword-line", color: "#00f5d4" },
  { label: "제작한 영상", value: "8", icon: "ri-video-line", color: "#f72585" },
  { label: "획득한 XP", value: "4,820", icon: "ri-coin-line", color: "#ffd60a" },
  { label: "받은 좋아요", value: "2,341", icon: "ri-heart-line", color: "#4cc9f0" },
  { label: "공유 횟수", value: "156", icon: "ri-share-forward-line", color: "#b44fff" },
  { label: "획득 배지", value: "3개", icon: "ri-award-line", color: "#ff6b35" },
];

const weeklyChallenge = [
  { rank: 1, name: "AnimeMaster_S", xp: 3200, change: "+2" },
  { rank: 2, name: "CosmicArtist", xp: 2890, change: "0" },
  { rank: 3, name: "RetroWave_S", xp: 2540, change: "+5" },
  { rank: 4, name: "NeonDreamer", xp: 2210, change: "-1" },
  { rank: 5, name: "StarCreator_K", xp: 1980, change: "+3" },
  { rank: 6, name: "UrbanKing_R", xp: 1750, change: "+1" },
  { rank: 7, name: "SoundRider_M", xp: 1620, change: "-2" },
  { rank: 8, name: "PixelWitch_J", xp: 1430, change: "0" },
];

export default function InteractionPage() {
  const [activeTab, setActiveTab] = useState<"leaderboard" | "badges" | "weekly">("leaderboard");

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />

      {/* Hero */}
      <div className="relative overflow-hidden pt-24 pb-16">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/a9afe3a853bd7bde466820455014594b.jpg"
            alt="Interaction Hero"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f]/70 via-[#0a0a0f]/50 to-[#0a0a0f]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-2 text-sm text-white/40 mb-6">
            <Link to="/" className="hover:text-white/70 transition-colors cursor-pointer">홈</Link>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs" />
            </div>
            <span className="text-white/70">인터랙션</span>
          </div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#f72585]/20 to-[#ffd60a]/20 border border-white/10">
              <i className="ri-trophy-line text-xl text-[#f72585]" />
            </div>
            <span className="text-[#f72585] text-sm font-semibold tracking-widest uppercase">Interaction Hub</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight mb-3">
            팬 인터랙션
            <span className="bg-gradient-to-r from-[#f72585] via-[#ffd60a] to-[#00f5d4] bg-clip-text text-transparent ml-3">
              허브
            </span>
          </h1>
          <p className="text-white/50 text-base max-w-xl">
            캠페인을 완료하고 리더보드에 올라 배지를 획득하세요. 최고의 크리에이터가 되어보세요.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-24">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left - My Stats */}
          <div className="w-full lg:w-80 flex flex-col gap-5">
            {/* Profile Card */}
            <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-2xl overflow-hidden border-2 border-[#00f5d4]/60 flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=young%20person%20portrait%20casual%20style%20neutral%20background%20friendly%20smile&width=60&height=60&seq=my-profile-001&orientation=squarish"
                    alt="My Profile"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-white font-bold text-base">나의 프로필</div>
                  <div className="flex items-center gap-1.5 mt-1">
                    <span className="px-2 py-0.5 rounded-full bg-[#00f5d4]/15 border border-[#00f5d4]/30 text-[#00f5d4] text-[10px] font-semibold">Lv.7</span>
                    <span className="text-white/40 text-xs">Creator</span>
                  </div>
                </div>
              </div>

              {/* Level Progress */}
              <div className="mb-5">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white/60 text-xs">레벨 진행도</span>
                  <span className="text-[#00f5d4] text-xs font-bold">68%</span>
                </div>
                <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full rounded-full bg-gradient-to-r from-[#00f5d4] to-[#f72585]" style={{ width: "68%" }} />
                </div>
                <div className="flex justify-between text-[10px] text-white/30 mt-1">
                  <span>4,820 XP</span>
                  <span>다음 레벨까지 2,180 XP</span>
                </div>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-3">
                {myStats.map((stat) => (
                  <div key={stat.label} className="rounded-xl bg-white/5 border border-white/5 p-3">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${stat.icon} text-sm`} style={{ color: stat.color }} />
                      </div>
                      <span className="text-white font-bold text-sm">{stat.value}</span>
                    </div>
                    <div className="text-white/40 text-[10px]">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
              <h3 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">빠른 이동</h3>
              <div className="flex flex-col gap-2">
                {[
                  { label: "캠페인 도전하기", icon: "ri-sword-line", href: "/quests", color: "#00f5d4" },
                  { label: "커뮤니티 피드", icon: "ri-community-line", href: "/community", color: "#4cc9f0" },
                  { label: "아티스트 탐색", icon: "ri-user-star-line", href: "/artists", color: "#f72585" },
                ].map((action) => (
                  <Link
                    key={action.label}
                    to={action.href}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl border border-white/5 bg-white/5 hover:border-white/15 hover:bg-white/10 transition-all cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${action.color}18` }}>
                      <i className={`${action.icon} text-sm`} style={{ color: action.color }} />
                    </div>
                    <span className="text-white/70 text-sm hover:text-white transition-colors">{action.label}</span>
                    <div className="ml-auto w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-white/30 text-sm" />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Tabs Content */}
          <div className="flex-1">
            {/* Tabs */}
            <div className="flex items-center gap-1 p-1 rounded-full bg-white/5 border border-white/10 w-fit mb-8">
              {([
                { key: "leaderboard", label: "전체 리더보드" },
                { key: "weekly", label: "주간 챌린지" },
                { key: "badges", label: "배지 컬렉션" },
              ] as const).map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    activeTab === tab.key
                      ? "bg-gradient-to-r from-[#f72585] to-[#ffd60a] text-white"
                      : "text-white/50 hover:text-white"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Leaderboard */}
            {activeTab === "leaderboard" && (
              <div className="flex flex-col gap-3">
                {leaderboard.map((user, i) => (
                  <div
                    key={user.rank}
                    className={`flex items-center gap-4 p-5 rounded-2xl border transition-all duration-200 ${
                      i === 0 ? "border-[#ffd60a]/30 bg-[#ffd60a]/5" : "border-white/10 bg-white/5 hover:border-white/20"
                    }`}
                  >
                    <div className="w-8 text-center flex-shrink-0">
                      {i < 3 ? (
                        <i className="ri-trophy-fill text-xl" style={{ color: rankColors[i] }} />
                      ) : (
                        <span className="text-white/40 font-bold text-sm">#{user.rank}</span>
                      )}
                    </div>
                    <div className="w-12 h-12 rounded-full overflow-hidden border-2 flex-shrink-0" style={{ borderColor: i < 3 ? rankColors[i] : "rgba(255,255,255,0.2)" }}>
                      <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-white font-semibold text-sm truncate">{user.name}</span>
                        <span className="px-2 py-0.5 rounded-full bg-white/10 text-white/50 text-[10px] flex-shrink-0">{user.badge}</span>
                      </div>
                      <div className="text-white/40 text-xs mt-0.5">영상 {user.videos}개 제작</div>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <div className="text-white font-black text-base">{user.xp.toLocaleString()}</div>
                      <div className="text-white/40 text-xs">XP</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Weekly Challenge */}
            {activeTab === "weekly" && (
              <div>
                <div className="rounded-2xl border border-[#ffd60a]/20 bg-[#ffd60a]/5 p-5 mb-6">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-fire-line text-xl text-[#ffd60a]" />
                    </div>
                    <div>
                      <div className="text-white font-bold text-sm">이번 주 챌린지</div>
                      <div className="text-white/40 text-xs">2026.04.07 ~ 04.13 · 남은 시간 5일</div>
                    </div>
                  </div>
                  <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                    <div className="h-full rounded-full bg-gradient-to-r from-[#ffd60a] to-[#ff6b35]" style={{ width: "42%" }} />
                  </div>
                </div>
                <div className="flex flex-col gap-3">
                  {weeklyChallenge.map((user, i) => (
                    <div
                      key={user.rank}
                      className={`flex items-center gap-4 p-4 rounded-2xl border transition-all ${
                        i < 3 ? "border-[#ffd60a]/20 bg-[#ffd60a]/5" : "border-white/10 bg-white/5"
                      }`}
                    >
                      <div className="w-8 text-center flex-shrink-0">
                        {i < 3 ? (
                          <i className="ri-trophy-fill text-lg" style={{ color: rankColors[i] }} />
                        ) : (
                          <span className="text-white/40 font-bold text-sm">#{user.rank}</span>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <span className="text-white font-semibold text-sm">{user.name}</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <span
                          className={`text-xs font-semibold ${
                            user.change.startsWith("+") ? "text-[#00f5d4]" : user.change === "0" ? "text-white/30" : "text-[#f72585]"
                          }`}
                        >
                          {user.change !== "0" ? user.change : "—"}
                        </span>
                        <div className="text-right">
                          <div className="text-white font-bold text-sm">{user.xp.toLocaleString()}</div>
                          <div className="text-white/40 text-[10px]">주간 XP</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Badges */}
            {activeTab === "badges" && (
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                {badges.map((badge) => (
                  <div
                    key={badge.id}
                    className={`rounded-2xl border p-6 text-center transition-all duration-200 ${
                      badge.earned ? "border-white/20 bg-white/5 hover:border-white/30" : "border-white/5 bg-white/2 opacity-50"
                    }`}
                  >
                    <div
                      className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4"
                      style={{
                        background: badge.earned ? `linear-gradient(135deg, ${badge.color}30, ${badge.color}10)` : "rgba(255,255,255,0.05)",
                        border: `1px solid ${badge.earned ? badge.color + "40" : "rgba(255,255,255,0.1)"}`,
                      }}
                    >
                      <i className={`${badge.icon} text-2xl`} style={{ color: badge.earned ? badge.color : "rgba(255,255,255,0.3)" }} />
                    </div>
                    <div className="text-white font-bold text-sm mb-1">{badge.name}</div>
                    <div className="text-white/40 text-xs mb-3">{badge.description}</div>
                    {badge.earned ? (
                      <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#00f5d4]/10 border border-[#00f5d4]/30">
                        <i className="ri-check-line text-[#00f5d4] text-xs" />
                        <span className="text-[#00f5d4] text-xs font-medium">획득 완료</span>
                      </div>
                    ) : (
                      <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/5 border border-white/10">
                        <i className="ri-lock-line text-white/30 text-xs" />
                        <span className="text-white/30 text-xs">미획득</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
